<template>
	<div class="page-wrapper">
		<div class="page-wrapper-card flex-full">
			<custom-table ref="tableRef" name="caseTable" :tabs="tabs" :headers="headers" :searchParams="searchParams" :config="config" @operate="handleOperation" :showMore="true">
				<!-- <template #extra-btn>
					<xl-button size="large" @click="handleExport">{{ $t( 'button.export' ) }}</xl-button>
				</template> -->
			</custom-table>
		</div>
	</div>
	 <!-- 售后弹窗 -->
	 <afterSalesDialog ref="afterSalesRef" @uploadTable="uploadTable"></afterSalesDialog>
</template>

<script setup>
import { XlInput, XlSelect, XlDatePicker, XlMessageBox, XlTag, XlRadio, XlRadioGroup, XlButton, XlMessage, XlTooltip } from '@shining3d/ui-components';
import { ref, h, onMounted, reactive, watch, computed, nextTick } from 'vue';
import CustomTable from '../../components/table/index.vue';
import { useLang } from '@shining3d/common-module/utils/lang';
import { $convertUTCDateToLocalDate, $convertLocalDateToUTCDate, $timeUnit } from '../../utils/common.js';
import orderApi from "../../api/order";
import caseApi from "../../api/case";
import afterSalesDialog from './components/afterSalesDialog.vue'
import { useStore } from 'vuex';
import { Download, DeleteFilled, Kejian, Pinter } from '@shining3d/icons-vue';
import { orderStatusType, timeMap } from '../../common/enum';
import router from "@/router";
import Bus from '../../utils/bus.js';
import { VueCookieNext } from 'vue-cookie-next';
import _get from 'lodash/get';

import aiIcon from '../../assets/image/ai_icon.svg';
const $store = useStore();
// import { checkAuth } from '@/utils/common';
// import { yesOrNo } from '@/utils/enum';

const { $t } = useLang( '@shining3d/xl-design-order' );
const { $t: $tapp } = useLang( '@shining3d/app' );

// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
// 获取列表数据，并格式化
const getData = async ( data ) => {
	const params = {
		...data,
		lang: VueCookieNext.getCookie('lang'),
		orgID: institutionId
		// orgID: institutionId
	}
	// const { result, status } = await caseApi.fetchCaseList( formatSearch( data ));
	const { result, status } = await orderApi.listCloudOrder(formatSearch( params ));
	let list = [];
	if ( status === 'success' ){
		list = ( result?.result || []).map(( item ) => ({
			...item, 
			orderID: item.id
		}));
	}
	return { status, result, list };
};

// 格式化搜索参数
const formatSearch = ( searchForm ) => {
	searchForm.orderState  = searchForm.status === '0' ? '' : searchForm.status;
	if ( searchForm.createOn ) {
		searchForm.beginTime = $convertLocalDateToUTCDate( searchForm.createOn[ 0 ] + ' 00:00:00' );
		searchForm.endTime = $convertLocalDateToUTCDate( searchForm.createOn[ 1 ] + ' 23:59:59' );
	} else {
		searchForm.beginTime = '';
		searchForm.endTime = '';
	}
	delete searchForm.createOn;
	return searchForm;
};
// 是否加急下拉
const isUrgentOptions = [
	{label: $t('design.order.yes') || '是', value: '1'},
	{label: $t('design.order.no') || '否', value: '0'},
];

// 设计结果类型下拉
const designResultOptions = [
	// {label: $t('design.order.all') || '全部', value: ''},
	{label: $t('design.order.manualOrder') || '人工设计', value: 'manualOrder'},
	{label: $t('design.order.aiOrder') || '自动化设计', value: 'aiOrder'},
];
// let isUrgentOptions = reactive([])
//设计类型下拉
const productTypeOptions = ref([]);
//设计产品下拉
const productOptions = ref([]);
const handleTypeChange = (value) => {
	productOptions.value = []
	tableRef.value.searchData.productConfig = '';
	if( value ) {
		const productArr = productTypeOptions.value.find((item) => item.value === value)?.productList;
		productArr?.forEach((item) => {
			productOptions.value.push({
				label: item?.productConfigName,
				value: item?.productConfig
			})
		})
	} else {
		productTypeOptions.value.forEach((item) => {
			item?.productList?.forEach((it) => {
				productOptions.value.push({
					label: it?.productConfigName,
					value: it?.productConfig
				})
			})
		})
	}
	searchParams.value.forEach((item) =>{
		if (item.key === 'productConfig') {
			item.bind.options = productOptions.value;
		}
	});
}
const getProduct = () => {
	productOptions.value = [];
	caseApi.fetchProduct({
		lang: VueCookieNext.getCookie('lang'),
		orgID: institutionId
	}).then((res) => {
		if ( res && res.status === 'success' ) {
			productTypeOptions.value = (res.result?.products || []).map((item) => ({
				label: item?.typeName,
				value: item?.productType,
				productList: item?.productList
			}))
			// res.result?.forEach((item) => {
			// 	item.productList.forEach((it) => {
			// 		productOptions.value.push({
			// 			label: it?.productContent,
			// 			value: it?.productConfig
			// 		})
			// 	})
			// })
			handleTypeChange(tableRef.value?.searchData?.productType)
			searchParams.value.forEach((item) =>{
				if( item.key === 'productType'){
					item.bind.options = productTypeOptions.value;
				} 
				// else if (item.key === 'productConfig') {
				// 	item.bind.options = productOptions.value;
				// }
			});
		}
	})
};
getProduct();
// 一些列表配置，可扩展
const config = { getData };

const getAiReasons = (reasons) => {
	let list = []
	if( reasons ){
		reasons.forEach((item) => {
			item.langs.forEach((it) => {
				if( it.lang === VueCookieNext.getCookie('lang')){
					list.push(it.name)
				}
			})
		})
		return list?.join(';')
	} else {
		return '-'
	}
}
const tabs = [
	// 全部
	{ label: $t('design.order.all') || '全部', name: '', lazy: true },
	// 已发送
	{ label: $t('design.order.waitAccept') || '已发送', name: 'waitAccept', lazy: true },
	// 待设计
	// { label: $t('design.order.waitDesign') || '待设计', name: 'waitDesign', lazy: true },
	// 设计中
	{ label: $t('design.order.inDesign') || '设计中', name: 'inDesign', lazy: true },
	// 待验收
	{ label: $t('design.order.waitCheck') || '待验收', name: 'waitCheck', lazy: true },
	// 暂停中
	{ label: $t('design.order.pause') || '暂停中', name: 'pause', lazy: true },
	// 待恢复设计
	// { label: $t('design.order.waitRecover') || '待恢复设计', name: 'waitRecover', lazy: true },
	// 待重新设计
	// { label: $t('design.order.waitRedesign') || '待重新设计', name: 'waitRedesign', lazy: true },
	// 重新设计完成
	// { label: $t('design.order.redesignComplete') || '重新设计完成', name: 'redesignComplete', lazy: true },
	// 已取消
	// { label: $t('design.order.cancel') || '已取消', name: 'cancel', lazy: true },
	// 已完成
	{ label: $t('design.order.complete') || '已完成', name: 'complete', lazy: true }
];
const route = computed(()=>router.currentRoute.value);
const searchParams = ref([
	{
		key: 'orderState',
		initValue: '',  // initValue: 只初始化一次； defaultValue: 每次重置都设置为该值
		defaultValue: ''
	},
	{
		key: 'status',
		initValue: route.value.params.tabName || '',
	},
	{
		key: 'orderID',
		component: XlInput,
		initValue: route.value?.query?.orderID,
		defaultValue: '',
		bind: {
			placeholder: $t( 'design.creditCard.paymentCaseCode' ) || '案例编号',
			size: 'large',
			style: 'width: 120px',
			clearable: true
		}
	},
	{
		key: 'orderName',
		component: XlInput,
		bind: {
			placeholder: $t( 'design.orderDetail.caseName' ) || '案例名称',
			size: 'large',
			style: 'width: 123px',
			clearable: true
		}
	},
	{
		key: 'productType',
		component: XlSelect,
		// component: CategorySelect,
		bind: {
			placeholder: $t( 'design.orderDetail.designType' ) || '设计类型',
			size: 'large',
			style: 'width: 132px',
			clearable: true,
			options: productTypeOptions.value
		},
		event: {
            'change': handleTypeChange,
        }
	},
	{
		key: 'productConfig',
		component: XlSelect,
		// component: ProductSelect,
		bind: {
			placeholder: $t( 'design.orderDetail.designProduct' ) || '设计产品',
			size: 'large',
			style: 'width: 152px',
			clearable: true,
			options: productOptions.value
		}
	},
	{
		key: 'isUrgent',
		component: XlSelect,
		bind: {
			placeholder: $t( 'design.orderDetail.isUrgent' ),
			size: 'large',
			style: 'width: 130px',
			options: isUrgentOptions,
			clearable: true
		}
	},
	{
		key: 'orderType',
		component: XlSelect,
		fixed: true,
		defaultValue: '',
		bind: {
			placeholder: $t( 'design.order.orderDesignType' ),
			size: 'large',
			style: 'width: 190px',
			options: designResultOptions,
			clearable: true
		}
	},
	{
		key: 'createOn',
		component: XlDatePicker,
		bind: {
			placeholder: '',
			size: 'large',
			type: 'daterange',
			startPlaceholder: $t( 'design.order.startPlaceholder' ) || '创建开始日期',
			endPlaceholder: $t( 'design.order.endPlaceholder' ) || '创建结束日期',
			valueFormat: 'YYYY-MM-DD',
			style: 'width: 325px',
			clearable: true,
			disabledDate: (time) => time.getTime() > Date.now()
		} 
	}
]);

const headers = ref([
	{ prop: 'orderID', label: $t( 'design.creditCard.paymentCaseCode' ) || '案例编号', minWidth: 180, 
		cellRenderer: (row) =>
          h('span', {
            class: 'click-span',
            onClick: () => handleClick(row),
          }, row?.orderID),
	 },
	{ prop: 'orderName', label: $t('design.orderDetail.caseName') || '案例名称', minWidth: 150,
		cellRenderer: (row) =>
          h('span', {
            class: 'click-span',
            onClick: () => handleClick(row),
          }, row?.orderName),
	 },
	{ prop: 'productType', label: $t( 'design.orderDetail.designType' ) || '设计类型', minWidth: 150 },
	{ prop: 'productConfig', label: $t( 'design.orderDetail.designProduct' ) || '设计产品', minWidth: 150,
	  cellRenderer:  ( row ) => row?.aiOrder ? h( 'span', { className: 'ai-product-box' }, [ h('span', { className: 'ai-product-config' }, [ h( XlTooltip, { placement: 'top', content: row.productConfig, offset: '24'}, row.productConfig) ] ), h( 'img', { src: aiIcon })] ) : h('span', row.productConfig )
	 },
	{
		prop: 'aiReasons',
		label: $t( 'design.orderDetail.unavailableReason' ) || '不可用原因', 
		minWidth: 160,
		cellRenderer: ( row ) => row.aiResultState === 'failed' ? $t('design.order.aiModelDisable') : getAiReasons(row.aiReasons)
	},
	{ 
		prop: 'isUrgent', 
		label: $t( 'design.orderDetail.isUrgent' ) || '是否加急', 
		minWidth: 150,
		cellRenderer: ( row ) => row?.isUrgent === '0' ? $t('design.order.no') || '否' : $t('design.order.yes') || '是'
	},
	{
		prop: 'orderState',
		label: $t( 'design.status' ) || '状态',
		minWidth: 180,
		customColumnDisabled: true,
		customColumnNoShow: true,
		cellRenderer: ( row ) => h( XlTag, { type: orderStatusType[ row.orderState ] }, () => $t( `design.order.${row.orderState}` ))
	},
	{
		prop: 'createOn',
		label: $t( 'design.createOn' ) || '创建时间',
		minWidth: 200,
		sortable: 'custom',
		cellRenderer: ( row ) => $convertUTCDateToLocalDate( row.createOn )
	},
	{
		prop: 'deliveryDay',
		label: $t( 'design.order.deliveryTime' ) || '交付周期',
		minWidth: 150,
		// sortable: 'custom',
		// cellRenderer: ( row ) => row.deliveryDay + timeMap[row.deliveryUnit]
		cellRenderer: ( row ) => $timeUnit( VueCookieNext.getCookie('lang'), row.deliveryUnit, row.deliveryDay )
	},
	{ prop: 'createBy', label: $t( 'design.creator' ) || '创建人', width: 150 },
	{
		prop: 'changeOn',
		label: $t( 'design.changeOn' ) || '更新时间',
		minWidth: 200,
		sortable: 'custom',
		cellRenderer: ( row ) => $convertUTCDateToLocalDate( row.changeOn )
	},
	{
		prop: 'action',
		label: $t( 'design.operate' ),
		width: 220,
		fixed: 'right',
		customColumnDisabled: true,
		customColumnNoShow: true,
		operations: [
			{ 
				key: 'viewDetail', 
				name: $t( 'design.viewDetail' ), 
				value: Kejian
			},
			{
				key: 'cancelOrder',
				name: $t( 'design.cancel' ),
				// value: CancellationOfOrder,
				iconName: 'jujuejiedan',
				// 只有待接单的状态 才可以取消订单
				showFn: ( row ) => row.orderState === 'waitAccept'
			},
			{
				key: 'acceptanceCheck',
				name: $t( 'design.order.acceptanceCheck' ),
				// value: Kejian,
				iconName: 'jiedan',
				showFn: ( row ) => row.orderState === 'waitCheck' && !( row.aiOrder && row.orderSource === 'autoDesigner')
			},
			{
				key: 'acceptanceCheckOnly',
				name: $t( 'design.order.acceptanceDetail' ) || '查看设计文件',
				iconName: 'chakansheji21',
				// 已完成 和 重新设计完成 支持查看设计结果文件
				showFn: ( row ) => ['complete', 'redesignComplete'].includes( row.orderState ) && !( row.aiOrder && row.orderSource === 'autoDesigner') && row.aiResultState !== 'failed'
			},
			{
				key: 'viewMessage',
				name: $t( 'design.order.viewMessage' ),
				// value: Communicate,
				iconName: 'faxiaoxi',
				showFn: ( row ) => row.orderState === 'pause'
			},
			// 售后 - 礼品卡支付的订单不能申请售后;支付状态未退款;订单状态已完成
			{
				key: 'afterSales',
				name: $t( 'design.order.afterSales' ),
				// value: AfterSales,
				iconName: 'tianchongchangyong',
				// showFn: ( row ) => (row.orderState === 'complete' || row.orderState === 'redesignComplete') && row.paymentState !== 'refund' && row.paymentWay !== 'giftCard'
				showFn: ( row ) => row.allowRedesign && !row.aiOrder
			},
			{
				key: 'downloadDesignFile',
				name: $t( 'design.order.downloadDesignFile' ),
				// value: Kejian,
				iconName: 'xiazai1',
				showFn: ( row ) => (row.orderState === 'complete' || row.orderState === 'redesignComplete') && !( row.aiOrder && row.orderSource === 'autoDesigner') && row.aiResultState !== 'failed'
			},
			{
				key: 'print',
				name: $tapp( 'user.case.toPrint' ),
				value: Pinter,
				// iconName: 'a-bianzu2',
				// showFn: ( row ) => row.orderState === 'complete' || row.orderState === 'redesignComplete'
				showFn: ( row ) => row.printSupport && ( !row.aiOrder || ( !!row.aiOrder && row.aiResultState === 'success' && Boolean( !row.aiReasons ) )) // 支持打印，若为ai单，则需要ai设计结果状态为成功,且不可用原因
			}
		]
		// cellRenderer: ( row ) => h( 'div', { class: 'flex', style:'flex: right' }, [
		// 	h( 'div', { class: 'text-button', onClick: () => handleView( row ) }, $t( 'button.checkDetail' )),
		// 	h( 'div', { class: 'text-button', onClick: () => handleReceive( row ) }, $t( '确认接单' ))
		// ])
	}
]);
const tableRef = ref();
// 查看详情
const handleView = ( data ) => {
	router.push({name: 'orderDetail', params: { id: data.id }});
};
// 取消订单
const handleCancelOrder = ( data ) =>{
	XlMessageBox({
		title: $t('design.orderDetail.cancelOrder') || '取消订单',
    	type: 'info',
		message: $t('design.orderDetail.cancelOrderTip') || '是否确认取消订单',
		cancelButtonText: $t('design.cancel') || '取消',
		confirmButtonText: $t('design.confirm') || '确定'
	}).
		then(() => {
			orderApi.changeCloudOrderState({
				orderID: data?.id,
				orgID: institutionId,
				action: 'toCancel'
			}).then((res) => {
				if( res && res.status === 'success' ){
					uploadTable();
					XlMessage({ type: 'success', message: $t('design.oder.cancelOrderSuccess') || '取消订单成功' });
				}
			})	
		}).
		catch(( e ) => {
			console.log( 'catch', e );
		});
}
// 更新表格
const uploadTable = () => {
	if( tableRef.value ){
		tableRef.value.handleSearch();
	}
}
// 验收
const handleAcceptanceCheck = ( data, type = 'action' ) =>{
	router.push({name: 'designAccept', params: { id: data.id }, query: { type }});
}
//查看消息
const handleViewMessage = ( data ) =>{
	router.push({name: 'orderDetail', params: { id: data.id }, query: { type: 'caseCommunication' }});
}
const afterSalesRef = ref()
// 售后
const handleAfterSales = ( data ) =>{
	afterSalesRef.value.show(data);
}
// 下载设计文件
const handleDownloadDesignFile = ( data ) =>{
	router.push({name: 'orderDetail', params: { id: data.id }, query: { type: 'dataDownload' }});
};
// 清除tooltip
const closeTableBtnTooltip = () => {
	const popper = document.querySelectorAll( '.el-popper.is-dark.xl-popper' );
	if ( popper && popper.length ) {
		popper.forEach(( v ) => {
			v.style.display = 'none';
		});
	}
}

// 添加该订单下所有设计结果文件至待打印列表
const handleGoPrint = ( data ) => {
	Bus.$emit( 'preprintPanelVisible', true ); // 在抽屉未渲染时可能会有接口请求先后顺序问题，故先展开。
	nextTick(() => {
		Bus.$emit( 'addPreprintItem', { sourceID: data.id });
	});
	// router.push({name: 'orderDetail', params: { id: data.id }, query: { type: 'dataDownload' }});
};

const handleOperation = ({ key, index, data }) => {
	closeTableBtnTooltip();
	if ( key === 'viewDetail' ){
		handleView( data );
	} else if ( key === 'cancelOrder' ) {
		handleCancelOrder(data);
	}else if ( key === 'acceptanceCheck' ) {
		handleAcceptanceCheck(data);
	}else if ( key === 'viewMessage' ) {
		handleViewMessage(data);
	}else if ( key === 'afterSales' ) {
		handleAfterSales(data);
	}else if ( key === 'downloadDesignFile' ) {
		handleDownloadDesignFile(data);
	} else if ( key === 'acceptanceCheckOnly' ) {
		handleAcceptanceCheck(data, 'info');
	} else if ( key === 'print' ) {
		handleGoPrint( data );
	}
};
const handleClick = (data) => {
	handleView( data );
}

Bus.$on( 'updateOrderList', uploadTable );

</script>

<style lang="scss" scoped>
.page-wrapper-card{
	height: 100%;
    flex: 1;
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    // flex: 1;
	padding: 0px;
    overflow: hidden;
	// :deep(.el-table--border .el-table__inner-wrapper){
	// 	height: 100%;
	// }
	// :deep(.el-table__body-wrapper){
	// 	height: calc(100% - 68px); 
	// }
	:deep(.xl-icon){
		margin: 0 !important;
	}
	.iconfont{
		margin: 0 !important;
	}
	:deep(.xl-table.el-table.el-table--border .el-table__cell){
		.click-span{
			cursor: pointer;
			&:hover{
				color: #5587FF;
			}
		}
	}
	:deep(.ai-product-config){
		margin-right: 4px;
		// max-width: calc(100% - 10px);
		// box-sizing: border-box;
		text-overflow: ellipsis;
		overflow: hidden;
		// display: block;
	}
	:deep(.ai-product-box){
		// padding-right: 10px;
		display: flex;
		// img{
		// 	margin-right: 13px;
		// }
	}
}
</style>